import styled from "styled-components";

export const DashboardTopSection = styled.div`
  margin: 0 10%;
  display: grid;
  grid-template-columns: 1fr 3fr 1fr;
  /* justify-content: space-between; */
  align-items: baseline;
  

  .view {
    color: #ffffff;
    font-weight: 700;
    border: 1px solid #808080;
    border-radius: 8px;
    text-align: center;

    @media (max-width: ${({ theme }) => theme.mobile.md}) {
      width: 100%;
    }
  }
  .visit {
    border-radius: 0.5rem;
    border: 1px solid #808080;
    background: #fcfcfc;
    border-radius: 8px;
    padding: 0.5em 1.1em;
    align-items: center;
    font-size: 12px;
    display: flex;
    width: 7.1875rem;
    height: 2.5rem;
    flex-shrink: 0;
    justify-content: center;
    align-items: center;
    @media (max-width: ${({ theme }) => theme.mobile.md}) {
      display: none;
    }

    h2 {
      font-size: 1em;
      font-weight: 700;
      cursor: pointer;
      margin-right: 0.6em;
      @media (max-width: ${({ theme }) => theme.mobile.md}) {
        font-size: 0.8em;
      }
    }
  }

  @media (max-width: ${({ theme }) => theme.mobile.md}) {
    display: block;
  }
`;
export const Menu = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 3.125em;
  width: 23.9375em;
  flex-shrink: 0;
  border-radius: 0.6875rem;
  background: #f2f9ff;
  padding: 1em 2.7em;
  /* margin-left: -2em; */
  div {
    width: 0.0625rem;
    height: 0.875rem;
    flex-shrink: 0;
    background: #d9d9d9;
  }
  .active {
    color: #000;
    font-family: Poppins;
    font-size: 0.875em;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
  }
  h5 {
    color: #696969;
    font-family: Poppins;
    font-size: 0.875em;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    cursor: pointer;
  }
  @media (max-width: ${({ theme }) => theme.mobile.md}) {
    width: 120%;
    padding: 0em 1.2em;
    position: relative;
    left: 50%;
    transform: translateX(-50%);
    margin-top: 1.19em;
    margin-left: 0em;
    align-self: center;
  }
`;
